import React, { useState, useEffect } from 'react';
import { Phone, Menu, X, Siren, Heart } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { contactInfo } from '../mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    // If not on home page, navigate there first
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsMobileMenuOpen(false);
  };

  const navItems = [
    { label: 'Home', id: 'hero' },
    { label: 'Über uns', id: 'about' },
    { label: 'Leistungen', id: 'services' },
    { label: 'Verfügbarkeit', id: 'availability' },
    { label: 'Termin buchen', id: 'booking' },
    { label: 'Pfotenflatrate', id: 'flatrate' },
    { label: 'Bewertungen', id: 'review' },
    { label: 'Kontakt', id: 'contact' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div
            className="flex items-center cursor-pointer group"
            onClick={() => scrollToSection('hero')}
          >
            <div className="relative">
              <div className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-orange-500 bg-clip-text text-transparent group-hover:scale-105 transition-transform duration-300">
                Dom's Pfotenexpress
              </div>
              <div className="text-xs text-gray-600 mt-1 ml-1">Ihr Tier-Taxi in Hagen</div>
            </div>
          </div>

          <nav className="hidden lg:flex items-center space-x-1">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-blue-600 rounded-lg hover:bg-blue-50 transition-all duration-200"
              >
                {item.label}
              </button>
            ))}
            <button
              onClick={() => navigate('/kombi-transport')}
              className="px-4 py-2 text-sm font-medium text-green-700 hover:text-green-800 rounded-lg hover:bg-green-50 transition-all duration-200 flex items-center gap-1"
            >
              <Heart className="h-4 w-4" />
              Tierschutz
            </button>
          </nav>

          <div className="hidden lg:flex items-center space-x-3">
            <a
              href={`tel:${contactInfo.phone}`}
              className="flex items-center space-x-2 bg-gradient-to-r from-red-500 to-red-600 text-white px-6 py-3 rounded-full font-semibold shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300 animate-pulse-slow"
            >
              <Siren className="h-5 w-5" />
              <span>24/7 Notdienst</span>
            </a>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
          >
            {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200 bg-white/95 backdrop-blur-md">
            <nav className="flex flex-col space-y-2">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="px-4 py-2 text-left text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
                >
                  {item.label}
                </button>
              ))}
              <button
                onClick={() => { navigate('/kombi-transport'); setIsMobileMenuOpen(false); }}
                className="px-4 py-2 text-left text-green-700 hover:text-green-800 hover:bg-green-50 rounded-lg transition-colors flex items-center gap-2"
              >
                <Heart className="h-4 w-4" />
                Tierschutz Kombi-Transport
              </button>
              <a
                href={`tel:${contactInfo.phone}`}
                className="flex items-center justify-center space-x-2 bg-gradient-to-r from-red-500 to-red-600 text-white px-6 py-3 rounded-full font-semibold mt-4 shadow-lg"
              >
                <Siren className="h-5 w-5" />
                <span>24/7 Notdienst</span>
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
